export default __webpack_public_path__ + "static/media/travel-icon.04eba9d0.svg";